import { render, staticRenderFns } from "./HealthcheckLogs.vue?vue&type=template&id=2b579497&scoped=true&"
import script from "./HealthcheckLogs.vue?vue&type=script&lang=js&"
export * from "./HealthcheckLogs.vue?vue&type=script&lang=js&"
import style0 from "./HealthcheckLogs.vue?vue&type=style&index=0&id=2b579497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b579497",
  null
  
)

export default component.exports